import styled from "styled-components";

export const TitleStyled = styled.h2`
  color: ${({ theme }) => theme.colors.text.black};
  font-weight: 500;
  /* font-size: 24px; */
`;
